import * as React from 'react';

import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import {CharismaEventApi} from '../api/events/CharismaEventApi.tsx'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { Link } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Typography from'@mui/material/Typography'

import { ValidateDate, ValidateDateRange, ValidateString } from '../utils/Validator.tsx';

export default function CharismaStatsForm(props){
    

    const [fError, setFError] = React.useState(0);
    const [fromDate, setFromDate] = React.useState(props.fromDate);
    const [toDate, setToDate] = React.useState(props.toDate);
    const [sError, setSError] = React.useState(0);
    const [dateError, setDateError] = React.useState(0);
    const [eError, setEError] = React.useState(0);
    const [wait, setWait] = React.useState(false);
    const [link, setLink] = React.useState(null);   
    const [error, setError] = React.useState(0);
    
        
    function handleSubmit(){
        
        let lValidMin: number = ValidateDate(fromDate);
        setSError(lValidMin);

        
        let lValidMax : number = ValidateDate(toDate);
        setEError(lValidMax);
                        
        if(lValidMax === 0 && lValidMin === 0){
            setWait(true);
            const lResponse = CharismaEventApi.GetStats(fromDate, toDate);
            lResponse.then((value)=>{
                if(value.error === 0){
                    setLink(value.link)
                    setWait(false);
                }
                else{
                    setError(value.error);   
                    setWait(false);
                }
            }).catch((error)=>{
            
            })
        }               
    }
    
    return(
        <Dialog
            open={true}
        >
            <DialogTitle>
                {props.title === undefined ?
                    'Bilan des interventions'
                    :
                    props.title
                }
            </DialogTitle>
            <DialogContent>

                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="fromDate"
                    label="Date de début après le"
                    name="fromDate"
                    InputLabelProps={{ shrink: true, required: true }}
                    type={'date'}
                    error={sError > 0}
                    helperText={sError === 1 ? 'Date invalide' : null }
                    value={fromDate}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setFromDate(event.target.value);
                    }}
                />
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="toDate"
                    label="Date de fin avant le"
                    name="toDate"
                    InputLabelProps={{ shrink: true, required: true }}
                    type={'date'}
                    error={eError > 0}
                    helperText={eError === 1 ? 'Date invalide' : null}               
                    value={toDate}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        setToDate(event.target.value);
                    }}
                />
                
                {dateError === 1 ?
                    <Alert severity="error">{'La date de début est supérieure à la date de fin'}</Alert>
                    :
                    null
                }
                {wait ?
                    <Typography>Création du fichier en cours...</Typography>
                    :
                    null
                }
                {link !== null ?
                    <Link to={link} download target="_blank">Télécharger</Link>
                    :
                    null
                }
                {
                    error === 2?
                        <Alert severity="error">{'Aucune formation ne correpond aux dates'}</Alert>
                    :
                    null
                }
            </DialogContent>
            <DialogActions>             
                {link === null ?   
                    <Button disabled={wait} onClick={()=>handleSubmit()}>Valider</Button>
                    :
                    null
                }
                <Button disabled={wait} onClick={()=>props.handleCancel()}>{link === null ? 'Annuler' : 'OK'}</Button>
            </DialogActions>
        </Dialog>        
    );
}